// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"94":"2b6e832e809fc2d49a9f","840":"38cad44f7e4d6dc2bfce"}[chunkId] + ".css";
};